import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "../../../../api/axios";

const initialState = {
  data: [],
  isAdding: false,
  status: null,
};

const token = userObj?.token;

export const addPickup = createAsyncThunk(
  "pickups/addPickup",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/Order/PostPick", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      return response?.data;
    } catch (err) {
      console.log(err.response);
      return rejectWithValue(err.response.data[0]);
    }
  }
);

const addPickupSlice = createSlice({
  name: "addPickup",
  initialState,
  reducers: {},
  extraReducers: {
    [addPickup.pending]: (state, action) => {
      state.status = "pending";
      state.isAdding = true;
    },
    [addPickup.fulfilled]: (state, action) => {
      state.status = "success";
      state.isAdding = false;
      state.data = action.payload;
      // localStorage.setItem('user', JSON.stringify(action.payload))
    },

    [addPickup.rejected]: (state, action) => {
      state.status = "failed";
      state.isAdding = false;
    },
  },
});

export default addPickupSlice.reducer;
